function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M233.208 53.7233L209.752 30.2662C205.892 26.4072 200.744 24.2812 195.256 24.2812C189.768 24.2812 184.621 26.4073 180.76 30.2673L55.6091 155.418C48.9811 162.046 42.4711 174.462 40.7891 183.683L36.2061 208.805C35.2551 214.019 36.3581 218.841 39.3111 222.382C42.1181 225.746 46.2991 227.6 51.0851 227.6C52.2521 227.6 53.4571 227.489 54.6681 227.267L79.7891 222.684C89.0111 221.001 101.426 214.492 108.054 207.863L233.207 82.7142C237.067 78.8542 239.193 73.7062 239.193 68.2192C239.194 62.7292 237.068 57.5823 233.208 53.7233ZM100.276 200.085C95.2731 205.089 84.7771 210.592 77.8151 211.862L52.6941 216.445C52.1331 216.548 51.5921 216.599 51.0861 216.599C50.0491 216.599 48.6301 216.38 47.7591 215.335C46.9321 214.344 46.6731 212.726 47.0281 210.778L51.6111 185.656C52.8811 178.694 58.3841 168.199 63.3881 163.194L171.711 54.8712L208.602 91.7632L100.276 200.085ZM225.43 74.9362L216.38 83.9863L179.489 47.0952L188.539 38.0452C190.322 36.2622 192.708 35.2803 195.257 35.2803C197.806 35.2803 200.192 36.2613 201.974 38.0443L225.43 61.5012C227.213 63.2832 228.194 65.6683 228.194 68.2183C228.194 70.7673 227.212 73.1522 225.43 74.9362Z",
  fill: "black"
});

function SvgIconPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 257 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon-pencil.f4f5f4ac4cf4cce2f64b535cc1f364c2.svg";
export { ForwardRef as ReactComponent };